module.exports = __webpack_public_path__ + "44a09cb71a521f8a12eecd60ca367f73.svg";